// Asset loader utility to ensure icons are available offline
// Icons are cached by service worker (sw-assets.js) for offline access

// Question and UI icons
const topicgreenIcon = '/assets/topicgreen.svg';
const questionmarkPriIcon = '/assets/questionmark_pri.svg';
const questionmarkIcon = '/assets/questionmark.svg';
const clockSecIcon = '/assets/clock_sec.svg';
const clockIcon = '/assets/clock.svg';

// Player/Play icons
const playerPlayIcon = '/assets/playerPlay.svg';
const playerPlayPriIcon = '/assets/playerPlay_pri.svg';
const playerPlayFilledIcon = '/assets/playerPlay_Filled.svg';
const playerPlayWhiteIcon = '/assets/playerPlay_white.svg';
const playerPlayFilledGreenIcon = '/assets/playerPlay_FilledGreen.svg';

// Action icons
const retryIcon = '/assets/retry.svg';
const circlecheckTerIcon = '/assets/circlecheck_ter.svg';
const circlecheckPriIcon = '/assets/circlecheck_pri.svg';
const circlecheckSecIcon = '/assets/circlecheck_sec.svg';
const circlecheckDisabledIcon = '/assets/circlecheck_disabled.svg';

// Media icons
const microphoneFilledIcon = '/assets/microphone_Filled.svg';
const cameraIcon = '/assets/camera.svg';
const webcamIcon = '/assets/WebCam.svg';

// Modal and UI icons
const xIcon = '/assets/x.svg';
const alertIcon = '/assets/alert.svg';
const analyticsIcon = '/assets/analytics.svg';
const guidelineIcon = '/assets/guideline.svg';
const supportIcon = '/assets/support copy.svg';

// Person/Avatar icons
const personIcon = '/assets/person.png';
const avatarIcon = '/assets/avatar.svg';

// Export icon map for easy access
export const icons = {
  // Question icons
  topicgreen: topicgreenIcon,
  questionmarkPri: questionmarkPriIcon,
  questionmark: questionmarkIcon,
  clockSec: clockSecIcon,
  clock: clockIcon,
  
  // Player icons
  playerPlay: playerPlayIcon,
  playerPlayPri: playerPlayPriIcon,
  playerPlayFilled: playerPlayFilledIcon,
  playerPlayWhite: playerPlayWhiteIcon,
  playerPlayFilledGreen: playerPlayFilledGreenIcon,
  
  // Action icons
  retry: retryIcon,
  circlecheckTer: circlecheckTerIcon,
  circlecheckPri: circlecheckPriIcon,
  circlecheckSec: circlecheckSecIcon,
  circlecheckDisabled: circlecheckDisabledIcon,
  
  // Media icons
  microphoneFilled: microphoneFilledIcon,
  camera: cameraIcon,
  webcam: webcamIcon,
  
  // Modal and UI icons
  x: xIcon,
  alert: alertIcon,
  analytics: analyticsIcon,
  guideline: guidelineIcon,
  support: supportIcon,
  
  // Person icons
  person: personIcon,
  avatar: avatarIcon,
};

// Helper function to get icon URL (with fallback)
export const getIcon = (iconName) => {
  return icons[iconName] || `/assets/${iconName}.svg`;
};

// Helper function for direct asset imports (for dynamic cases)
export const getAssetUrl = (assetPath) => {
  // If it's already a full URL, return as is
  if (assetPath.startsWith('http://') || assetPath.startsWith('https://')) {
    return assetPath;
  }
  
  // Remove leading slash if present
  const cleanPath = assetPath.startsWith('/') ? assetPath.slice(1) : assetPath;
  
  // Try to find in icons map first
  const iconKey = cleanPath.replace('assets/', '').replace('.svg', '').replace('.png', '');
  if (icons[iconKey]) {
    return icons[iconKey];
  }
  
  // Fallback to original path
  return assetPath;
};

